import { LitElement, html } from "lit-element";
import "./tone-viz";

class MidiContainer extends LitElement {
  static get properties() {
    return {
      availableInputs: { type: Array },
      value: { type: Number },
    };
  }

  constructor() {
    super();
  }

  render() {
    return html`
      <tone-viz
        name="horizontal"
        position="absolute"
        origin="bottom"
        noteWidthOrigin="right"
        transportNoteSpeed="50n"
        numNotes="32"
        noteFadeSpeed=".5"
        size="1"
        mode="sequential-position"
        width="100%"
        height="100%"
        backgroundColor="transparent"
        startColor="rgb(255, 255, 0)"
        endColor="rgb(200, 200, 0)"
        noteOpacity="1"
      ></tone-viz>

      <tone-viz
        name="horizontal"
        position="absolute"
        origin="top"
        transportNoteSpeed="50n"
        noteWidthOrigin="left"
        numNotes="32"
        noteFadeSpeed=".5"
        size="1"
        mode="sequential-position"
        width="100%"
        height="100%"
        backgroundColor="transparent"
        startColor="rgb(255, 255, 0)"
        endColor="rgb(200, 200, 0)"
        noteOpacity="1"
      ></tone-viz>
      
      <tone-viz
        name="horizontal"
        position="absolute"
        origin="right"
        noteHeightOrigin="bottom"
        transportNoteSpeed="50n"
        numNotes="32"
        noteFadeSpeed="1"
        lengthIteratorStep="${(1 / 32) * 100}"
        size="1"
        mode="sequential-position"
        startColor="rgb(0, 0, 100)"
      ></tone-viz>

      <tone-viz
        name="horizontal"
        position="absolute"
        origin="right"
        noteHeightOrigin="top"
        transportNoteSpeed="50n"
        numNotes="32"
        noteFadeSpeed="1"
        lengthIteratorStep="${(1 / 32) * 100}"
        size="1"
        mode="sequential-position"
        startColor="rgb(0, 0, 100)"
      ></tone-viz>

      <tone-viz
        name="horizontal"
        position="absolute"
        origin="left"
        noteHeightOrigin="top"
        transportNoteSpeed="50n"
        numNotes="32"
        noteFadeSpeed="1"
        lengthIteratorStep="${(1 / 32) * 100}"
        size="1"
        mode="sequential-position"
        startColor="rgb(0, 0, 100)"
      ></tone-viz>

      <tone-viz
        name="horizontal"
        position="absolute"
        origin="left"
        transportNoteSpeed="50n"
        noteHeightOrigin="bottom"
        numNotes="32"
        noteFadeSpeed="1"
        lengthIteratorStep="${(1 / 32) * 100}"
        size="1"
        mode="sequential-position"
        startColor="rgb(0, 0, 100)"
      ></tone-viz>

      <!-- <tone-viz
        name="horizontal"
        position="absolute"
        origin="left"
        transportNoteSpeed="50n"
        noteHeightOrigin="bottom"
        numNotes="32"
        noteFadeSpeed="1"
        size="1"
        mode="sequential-position"
        startColor="rgb(0, 0, 100)"
      ></tone-viz>

      <tone-viz
        name="horizontal"
        position="absolute"
        origin="right"
        transportNoteSpeed="50n"
        noteHeightOrigin="top"
        numNotes="32"
        noteFadeSpeed="1"
        size="1"
        mode="sequential-position"
        startColor="rgb(0, 0, 100)"
      ></tone-viz>

      <tone-viz
        name="horizontal"
        position="absolute"
        origin="left"
        transportNoteSpeed="50n"
        noteHeightOrigin="top"
        numNotes="32"
        noteFadeSpeed="1"
        size="1"
        mode="sequential-position"
        startColor="rgb(0, 0, 100)"
      ></tone-viz> -->
    `;
  }
}

customElements.define("midi-container", MidiContainer);
